import { Flex } from '@chakra-ui/react';
import { staticRoutesWithCustomSidebar } from 'Deer/constants/staticRoutesWithCustomSidebar';
import { useDispatch, useSelector } from 'react-redux';
import {
  REVIEW_FORM_STAGE,
  setReviewCreationKey,
  useReviewCreationDerivedMetaData,
  useReviewCreationV1Data,
} from 'reducers/reviewCreationV1Slice';
import { selectLoggedInEmployeeId } from 'selectors/loggedInEmployee';
import { checkEnableReviewWithoutSelfReview } from 'utils/helpers/featureFlags';

import { SettingsV1, Visibility } from 'assets/assetsV1/iconComponents';

import { REVIEW_PROVIDER_TYPES } from 'constants/ProjectConstants';

import { Button } from 'uiToolkitV1/Button';

import { LabelFieldWrapper } from '../components/LabelFieldWrapper';
import { SectionWrapper } from '../components/SectionWrapper';
import { FormsCards } from './formsComps/FormsCards';
import { FormsSelector } from './formsComps/FormsSelector';

export const PreviewFormButton = () => {
  const { feedbackFormId } = useReviewCreationV1Data();
  const loggedInEmployeeId = useSelector(selectLoggedInEmployeeId);

  const route = staticRoutesWithCustomSidebar.reviewsFormFilling
    .replace(':reviewId', feedbackFormId)
    .replace(':employeeId', loggedInEmployeeId);

  const providerType = checkEnableReviewWithoutSelfReview()
    ? REVIEW_PROVIDER_TYPES.MANAGER
    : REVIEW_PROVIDER_TYPES.SELF;

  const routeWithQuery = `${route}?isPreview=true&providerType=${providerType}`;

  return (
    <Button target="_blank" as="a" variant="outlined" StartIcon={Visibility} height="32px" href={routeWithQuery}>
      Preview form
    </Button>
  );
};

export const Forms = () => {
  const dispatch = useDispatch();

  const handlePanelOpen = () => {
    dispatch(setReviewCreationKey({ isFormsSettingsPanelOpen: true }));
  };
  const { reviewStage } = useReviewCreationV1Data();

  const { hasPeerForm, hasDLMForm } = useReviewCreationDerivedMetaData();
  const hasPeerOrDMLForm = hasPeerForm || hasDLMForm;

  const isDraft = reviewStage === REVIEW_FORM_STAGE.DRAFT;

  const rightComp = (
    <Flex gap={3}>
      <PreviewFormButton />
      {hasPeerOrDMLForm && (
        <Button variant="outlined" StartIcon={SettingsV1} height="32px" onClick={handlePanelOpen}>
          Configure
        </Button>
      )}
    </Flex>
  );

  return (
    <SectionWrapper
      title="Forms"
      subTitle="Reviewers, reviewer-wise form templates & form permissions"
      rightComp={rightComp}
      restrictAccess={!isDraft}
    >
      <LabelFieldWrapper label="Select reviewers">
        <FormsSelector />
      </LabelFieldWrapper>

      <LabelFieldWrapper label="Select form templates">
        <FormsCards />
      </LabelFieldWrapper>
    </SectionWrapper>
  );
};
